import React from 'react';
import i18next from 'i18next';
import { authRoles, PERMISSION } from 'app/auth';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'pharmacy', en);

const UpdatePharmacyConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Settings',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PHARMACY,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/pharmacy/:id',
      component: React.lazy(() => import('./UpdatePharmacy')),
    },
  ],
};

export default UpdatePharmacyConfig;
